<template>
  <div>
    <Header />
    <div class="main">
      <div class="c">
        <div class="message-box">
            <div class="message-inner">
                <img class="wan-img" src="@/assets/cepingwanc.png" alt="" />
                <div class="time-box">用&nbsp;时&nbsp;&nbsp;&nbsp;{{time}}</div>
                <div class="backbtn" @click="backAssess()">返回我的测评</div>
            </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Header from "../../../components/Header";
import services from "../../../config/services";
import { mapState } from "vuex";
export default {
  name: "assessEnd",
  components: {
    Header,
  },
  data() {
    return {
      time: this.$route.query.time,
    };
  },
computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
    })
  },
  created() {
  },
  mounted(){
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', this.preventBack);
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.preventBack);
  },

  methods: {
    preventBack() {
      history.pushState(null, document.title, location.href);
    },
    // 返回
    backAssess() {
      this.$router.push({
        path:  `/${this.loginUserInfo && this.loginUserInfo.school_code}/user/myAssess`,
        query: {
          tabs: 0,
        },
      });
    },
  },
};
</script>

<style scoped>
.main {
  background: #f6f6f6;
  padding-bottom: 10px;
}
.c {
  padding-top: 10px;
}
.message-box {
    width: 100%;
    background-color: #fff;
    height: calc(100vh - 100px);
    min-height: 740px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.message-inner {
    text-align: center;  
    /* padding-top: 120px; */
} 
.message-inner .wan-img {
    width: 284px;
    height: auto;
    margin-bottom: 40px;
}
.message-inner  .time-box {
    width: 360px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    background: #DEEBFE;
    font-weight: bold;
    font-size: 20px;
    color: #4479D9;
    margin: 0 auto 50px;
}
.message-inner .backbtn {
    width: 180px;
    height: 36px;
    line-height: 36px;
    background: #3977FF;
    border-radius: 18px;
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    margin: 0 auto;
    cursor: pointer;
}
</style>